import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'
import { useSessionTimeout } from '@context/SessionTimeoutContext'

import { Modal } from '@ui/components/Modal'
import { ProgressBar } from '@ui/components/ProgressBar'

export const SessionExpirationModal: BaseModalType = () => {
  const { redirectAfter, onLogout, onStayConnected, timer } = useSessionTimeout()

  const { t } = useTranslation()

  return (
    <Modal.Popup size='md'>
      <Modal.Header>{t('Your Session is About to Expire!')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('Your session will expire in', {
            minutes: redirectAfter / 60 / 1000,
          })}
        </Modal.Body.Text>
        <Modal.Body.Text>
          {t('Redirecting in', { seconds: Math.round(timer / 1000) })}
        </Modal.Body.Text>
        <ProgressBar color={'red'} percent={(timer / 1000 / (redirectAfter / 1000)) * 100} />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={onStayConnected}>
          {t('Stay Connected')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={onLogout}>{t('Log Out')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal.Popup>
  )
}
